import { Collapsible } from '../interfaces';
import { ComparabilitySearchMultiYear } from './comparability-search-multi-year';
import { ComparabilitySearchSingleYear } from './comparability-search-single-year';
import { RangeResultsDiscussion } from './range-results-discussion';

export class ComparabilitySearchFinalRangeOld implements Collapsible {
  numYearsOfData: number;
  averagingMethodology: string;
  statisticalMethodology: string;
  inRangeStatus: string;
  numCompsRemainingAfterBulk: number;
  numCompsRemainingAfterFine: number;
  multiYear: ComparabilitySearchMultiYear;
  singleYear: ComparabilitySearchSingleYear;
  rangeResultsDiscussion: RangeResultsDiscussion;
  collapsed: boolean;
  jurisdiction: string;
}
